import axios from 'axios'

export const createFormData = (body) => {
  let data = new FormData()
  Object.entries(body).forEach((b) => {
    data.append(b[0], b[1])
  })
  return data
}

export const getQueryParams = () => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  const params = Object.fromEntries(urlSearchParams.entries())
  return params
}

export const encryptMail = (mail) => {
  let splittedParts = mail.split('@')
  let encryptedPart = new Array(splittedParts[0].length - 1).join('*')
  return `${mail[0]}${mail[1]}${encryptedPart}@${splittedParts[1]}`
}

export const extractword = (str, start, end) => {
  var startindex = str.indexOf(start)
  var endindex = str.indexOf(end, startindex)
  if (startindex != -1 && endindex != -1 && endindex > startindex)
    return str.substring(startindex, endindex)
}

export const createCookie = (
  name,
  value,
  days = null,
  path = '/',
  domain = null,
  options = []
) => {
  let expires = ''
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = `; expires=${date.toUTCString()}`
  }

  let optionsValue = ''
  if (options && options.length > 0) {
    options.map((el, i) => {
      Object.entries(el).map((values) => {
        const [key, value] = values
        optionsValue = `${optionsValue}; ${key}${value ? `=${value}` : ''}`
      })
    })
  }

  document.cookie = `${name}=${value || ''}${expires}; path=${path}${
    domain ? `; domain=${domain}` : ''
  }${optionsValue}`
}

export const validatePassword = (string) => {
  const pattern =
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?!.*(.)\1{2,})(?=.*[@!#$^%&*();,.<>:\\\-={}+|?\/"\'\\\[\\\]\\\\]).{11,}$/
  let re = new RegExp(pattern)
  return re.test(string)
}

export const cspQuery = (csrfToken) => {
  let result = axios({
    url: `${process.env.REACT_APP_A2A_URL}/a2a-bff-first-entry-point?_format=json`,
    method: 'post',
    headers: {
      'X-CSRF-Token': `${csrfToken}`,
    },
    data: createFormData({ step: 0 }),
  })
  return result
}
